import { render, staticRenderFns } from "./termsOfService.vue?vue&type=template&id=c63db7ee&"
import script from "./termsOfService.vue?vue&type=script&lang=ts&"
export * from "./termsOfService.vue?vue&type=script&lang=ts&"
import style0 from "./termsOfService.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports